import React, {useMemo} from 'react'
import {ClientViewTalentProfile} from "./TalentProfilePage";
import {Route, Routes, useLocation, useParams, useSearchParams} from "react-router-dom";
import {Helmet} from "react-helmet";
import LoadingBanner from "../../components/LoadingBanner";
import Team from "../../models/Team";
import User from "../../models/User";

import PageError from "../../components/errors/PageError";
import ResourceNotFound from "../../components/errors/ResourceNotFound";
import {useProject} from "../../providers/ClientProjectProvider";
import {useAuth} from "../../providers/AuthProvider";
import {useAPI} from "../../config/API";
import TeamProvider, { useTeam, TeamContext} from "../../providers/TeamProvider";

import TalentProfileMembers from "./sections/TalentProfileMembers";
import ProfileLayoutWrapper from "./ProfileLayoutWrapper";
import TalentProfileSkills from "./sections/TalentProfileSkills";
import TeamProfileDetails from "./sections/TeamProfileDetails";

const components = {
    // industries_worked: { title: 'Industry Experience', element: TalentProfileIndustryExperience },
    // brands: { title: 'Brand Experience', element: TalentProfileBrandExperience },
    members: { title: 'Team Members', element: TalentProfileMembers },
    // key_clients: { title: 'Work Highlights', element: TalentProfileWorkHighlights },
    skills: { title: 'Skills', element: TalentProfileSkills },
    // talent_references: { title: 'References', element: TalentProfileReferences },
    // schools: { title: 'Education', element: TalentProfileEducation },
    // jobs: { title: 'Work History', element: TalentProfileWorkHistory },
    // certifications: { title: 'Certifications', element: TalentProfileCertifications },
    // awards: { title: 'Awards', element: TalentProfileAwards }
}


const TeamProfileLayout = ({ isLoading, children }) => {

    const {team, criteria} = useTeam();
    const profileNavItems = useMemo(() => {
        if (isLoading || !team) return [];

        let items = [];


        Object.keys(components).forEach(key => {
            if(key === 'members') {
                items.push({...components[key], items: {members: User.makeMany(team.positions || [])},criteria})
            }else if (team[key]?.length) {
                items.push({...components[key], items: team[key], criteria}, );
            }
        })
        return items;
    }, [isLoading])


    return (
        <ProfileLayoutWrapper sections={profileNavItems} isLoading={isLoading} type="Team">
            <TeamProfileDetails>
                {children}
            </TeamProfileDetails>
        </ProfileLayoutWrapper>
    )
}

const ClientViewTeamProfile = (props) => {
    const {auth} = useAuth();
    const {teamId, projectId,"*": tab} = useParams();
    const location = useLocation();

    const [searchParams, setSearchParams] = useSearchParams();

    const requestParams = useMemo(() => {
        let rParams = {browse: true, teamId: parseInt(teamId)};
        if (projectId && !TB.isNaN(projectId) && auth?.isClient()) {
            rParams.projectId = projectId;
        }
        return rParams
    }, [teamId, searchParams?.toString(), auth]);
    const {
        data: team,
        isInitialLoading: isLoading,
        error,
        refetch
    } = useAPI(
        ['fetchTeam', requestParams],
        {
            enabled: !props.model && !TB.isNaN(parseInt(teamId)),
            select: React.useCallback(
                (teamData) => {
                    let matchedTeam = TB.find(props.browseResults || [], ['id', parseInt(teamId)]) || {}
                    return Team.make({...teamData, ...matchedTeam})
                },
                []
            ),
        }
    );
    console.log('ClientViewTeamProfile', team)

    if (isLoading) {
        return (
            <div className="py-8 flex flex-col items-center justify-center flex-grow">
                <LoadingBanner message="Loading Team"/>
            </div>
        )
    }
    if (!isLoading && error) {
        return (
            <PageError exitLink={'./../'} exitText={'Take me back'}/>
        )
    }

    if(!isLoading && !team) {
        return <ResourceNotFound type="Team" exitLink={'./../'} exitText="Return to browse"/>
    }
    if (!team) {
        return null
    }

    return (
        <TeamProvider team={team} criteria={props.criteria}>
            <TeamContext.Consumer>
                {({ team }) => (team?.name ? (
                    <Helmet>
                        <title>{team.name} | Wripple</title>
                    </Helmet>
                ) : undefined)}
            </TeamContext.Consumer>
            <TeamContext.Consumer>
                {({isLoading, error}) => {
                    if (isLoading) {
                        return (
                            <div className="py-8 flex flex-col items-center justify-center flex-grow">
                                <LoadingBanner message="Loading Team"/>
                            </div>
                        )
                    }
                    if (!isLoading && error) {
                        return (
                            <PageError exitLink={'./../'} exitText={'Take me back'}/>
                        )
                    }

                    return (
                        <Routes>
                            <Route path={"*"} element={(
                                <TeamProfileLayout isLoading={isLoading}/>
                            )}/>
                            <Route path="talent-profiles/:profileId/*" element={<ClientViewTalentProfile team={team}/>}/>
                        </Routes>
                    )
                }}
            </TeamContext.Consumer>
        </TeamProvider>
    )
}

const ClientViewTeamCandidateProfile = (props) => {
    const {project} = useProject();

    return <ClientViewTeamProfile {...props} project={project}/>
}

export default ClientViewTeamProfile;

export {
    ClientViewTeamProfile,
    ClientViewTeamCandidateProfile
}